module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/LesMiserables_Horiz.ebb0428.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/LesMiserables_Horiz.jpg
// module id = xreP
// module chunks = 0